import { createAction } from '@reduxjs/toolkit';
import { UserActionTypes } from './UserActionTypes';
import { LoginUserModel, NewUserModel, UserModel } from './UserModel';

export const createUserAction = createAction(UserActionTypes.CREATE_USER, (newUser: NewUserModel) => {
  return {
    payload: {
      newUser,
    },
  };
});

export const authenticateUserAction = createAction(UserActionTypes.AUTHENTICATE_USER, (loginUser: LoginUserModel) => {
  return {
    payload: {
      loginUser,
    },
  };
});

export const getUserDataAction = createAction<string>(UserActionTypes.GET_USER);

export const storeUserDataAction = createAction(UserActionTypes.STORE_USER_DATA, (user: UserModel) => {
  return {
    payload: {
      user,
    },
  };
});

export const clearUserDataAction = createAction(UserActionTypes.CLEAR_USER_DATA);
